import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "box-border flex items-center gap-2 w-full bg-brand-secondary py-2 px-3 md:px-6"
}
const _hoisted_3 = ["innerHTML"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import DOMPurify from 'dompurify';
import { XIcon } from '@heroicons/vue/outline';

const rotationMs = 5000;


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroBanner',
  props: {
    announcement: {}
  },
  setup(__props: any) {

const props = __props;

// How long each announcement stays on screen before the ticker advances.
const store = useStore();

/**
 * The brand's own announcement first, then whatever the outage api returned.
 * Blank entries are skipped so they can't rotate in as an empty banner.
 */
const items = computed<string[]>(() => {
  const bodies = store.state.announcements
    .map((announcement: { body: string | null }) => announcement.body);

  return [props.announcement, ...bodies]
    .filter((body: string | null): body is string => Boolean(body?.trim()));
});

const index = ref(0);

// Falls back to the first item so a shrinking list can't render a hole.
const currentItem = computed(() => items.value[index.value] ?? items.value[0] ?? '');

// Announcement bodies come from the outage api, so sanitize before v-html.
const sanitizedCurrentItem = computed(() => DOMPurify.sanitize(currentItem.value));

let timer: number | undefined;

const stop = () => {
  if (timer) {
    window.clearInterval(timer);
    timer = undefined;
  }
};

const start = () => {
  stop();

  // A single announcement has nothing to rotate to.
  if (items.value.length > 1) {
    timer = window.setInterval(() => {
      index.value = (index.value + 1) % items.value.length;
    }, rotationMs);
  }
};

// Announcements arrive after mount, so restart the ticker when they land.
watch(items, () => {
  index.value = 0;
  start();
});

// Dismissal lasts for the session. The banner lives outside router-view, so it
// isn't remounted on navigation and won't reappear as the user moves around.
const dismissed = ref(false);

const dismiss = () => {
  dismissed.value = true;
  stop();
};

onMounted(start);
onBeforeUnmount(stop);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (items.value.length > 0 && !dismissed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "w-6 shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          _createVNode(_Transition, {
            name: "slide-fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("h2", {
                class: "flex-1 min-w-0 text-center text-white font-poppins text-xs",
                key: currentItem.value,
                innerHTML: sanitizedCurrentItem.value
              }, null, 8, _hoisted_3))
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            type: "button",
            class: "w-6 shrink-0 flex items-center justify-center p-1 leading-none text-white bg-transparent border-0 cursor-pointer opacity-80 hover:opacity-100",
            "aria-label": "Dismiss announcement",
            onClick: dismiss
          }, [
            _createVNode(_unref(XIcon), {
              class: "w-4 h-4",
              "aria-hidden": "true"
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})